import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useBranding, imgStyle } from "../context/BrandingContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";

import { GoogleButton } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const { branding } = useBranding();
  const crest = branding.images.login_crest;
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account created. Welcome.");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-grain flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src={crest.src} alt="Chapter crest"
               style={{ ...imgStyle(crest, 96), marginBottom: "1rem" }}
               className="h-auto drop-shadow-[0_0_24px_rgba(255,236,105,0.25)]" />
          <h1 className="font-serif-accent text-3xl sm:text-4xl text-[var(--sn-gold)] mb-1 text-center">Join the Chapter</h1>
          <p className="text-[var(--sn-border)] text-xs tracking-[0.25em] uppercase font-semibold">Request Member Access</p>
        </div>
        <form onSubmit={submit} className="glass-card rounded-2xl p-6 sm:p-8 space-y-5">
          <div className="space-y-2">
            <Label>Full Name</Label>
            <Input data-testid="register-name-input" required value={name}
              onChange={(e) => setName(e.target.value)} placeholder="John Q. Brother"
              className="bg-neutral-900 border-[var(--sn-border)] focus-visible:ring-[var(--sn-gold)]" />
          </div>
          <div className="space-y-2">
            <Label>Email</Label>
            <Input data-testid="register-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="brother@chapter.edu"
              className="bg-neutral-900 border-[var(--sn-border)] focus-visible:ring-[var(--sn-gold)]" />
          </div>
          <div className="space-y-2">
            <Label>Password (min 6)</Label>
            <Input data-testid="register-password-input" type="password" minLength={6} required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="bg-neutral-900 border-[var(--sn-border)] focus-visible:ring-[var(--sn-gold)]" />
          </div>
          <Button data-testid="register-submit-button" type="submit" disabled={loading}
            className="w-full bg-[var(--sn-gold)] hover:brightness-95 text-black font-bold h-11">
            {loading ? "Creating…" : "Create Account"}
          </Button>
          <div className="flex items-center gap-3 text-neutral-600 text-xs">
            <div className="flex-1 h-px bg-neutral-800" /> or <div className="flex-1 h-px bg-neutral-800" />
          </div>
          <GoogleButton />
          <p className="text-neutral-500 text-sm text-center">
            Already a member?{" "}
            <Link to="/login" className="text-[var(--sn-gold)] hover:brightness-90 underline">Sign in</Link>
          </p>
          <p className="text-xs text-neutral-500 text-center pt-2 border-t border-white/5">
            New accounts start as <span className="text-neutral-300">Member</span>. The President or Admin will elevate your rank.
          </p>
        </form>
      </div>
    </div>
  );
}
